import React, { Component } from "react"

import Header from '../../components/Header/Header';
import Content_QueEsAmibus from "./Content_QueEsAmibus";
import Footer from '../../components/Footer/Footer';

class QueEsAmibus extends Component {
    render() {
        return (

            <div class="main-container">
                <Header />
                <Content_QueEsAmibus />
                <Footer />
            </div>

        )
    }
}

export default QueEsAmibus;